import Card from '@/components/common/ui/Card';
import { Network, Cloud, ShieldCheck, Headphones, Database, Lightbulb } from "lucide-react";

const plans = [
    {
        title: "Network Management",
        description:
            "Ensure your network runs smoothly with our comprehensive management services, including monitoring, troubleshooting, and upgrades.",
        icon: Network,
    },
    {
        title: "Cloud Services Management",
        description:
            "Maximize the benefits of cloud technology. We manage your cloud infrastructure, ensuring security, scalability, and seamless integration with your existing systems.",
        icon: Cloud,
    },
    {
        title: "Cybersecurity Solutions",
        description:
            "Protect your business from threats with our robust cybersecurity measures, including firewalls, intrusion detection, and employee training.",
        icon: ShieldCheck,
    },
    {
        title: "Help Desk Support",
        description:
            "Our dedicated help desk team is available 24/7 to assist your employees with any IT issues, ensuring minimal disruption to your operations.",
        icon: Headphones,
    },
    {
        title: "Data Backup & Recovery",
        description:
            "Safeguard your critical data with our backup solutions and disaster recovery planning, ensuring your business can quickly recover from any data loss incidents.",
        icon: Database,
    },
    {
        title: "IT Consulting Services",
        description:
            "Leverage our expertise to align your IT strategy with your business goals. We provide guidance on technology investments, system upgrades, and digital transformation initiatives.",
        icon: Lightbulb,
    },
];

export default function OtherServices() {
    return (
        <section className="container pt-24 pb-28">
            <div className="text-center mb-12">
                <h3 className="text-3xl md:text-4xl font-bold text-white leading-tight mb-6">
                    Proactive Support for Seamless Business Operations
                </h3>
                <p className="text-textColor max-w-3xl md:text-lg mx-auto mb-12">
                    Ensure your business stays ahead with our Managed IT Proactive Support.
                </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">
                {plans.map((plan, index) => (
                    <Card
                        key={index}
                        title={plan.title}
                        description={plan.description}
                        icon={plan.icon}
                    />
                ))}
            </div>
        </section>
    );
}